import { useEffect, useState } from "react";
import {
  StaffItem,
  StaffList,
  StaffPopupLeft,
  StaffPopupRight,
  StaffPopupWrapper,
  StaffSearchButton,
  StaffSearchButtonWrapper,
  StaffSearchInput,
  StaffTitle,
} from "../styles/staff.style";
import {
  addPubStaff,
  deletePubStaff,
  getPubStaffList,
  PubStaffResponse,
} from "../../../api/cafe";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { loadingState } from "../../../recoil/loading.atom";
import { PopupContainer } from "../../../styles/popup";

const StaffPopup = ({
  setIsStaffManagementOpen,
}: {
  setIsStaffManagementOpen: any;
}) => {
  const [search, setSearch] = useState("");
  const [list, setList] = useState<PubStaffResponse[]>([]);

  const setLoading = useSetRecoilState(loadingState);

  const pub = useRecoilValue(pubState);

  async function getStaffList() {
    if (!pub) return;
    const res = await getPubStaffList(pub.id);
    setList(res);
  }

  async function addStaff() {
    if (!pub) return;
    setLoading(true);
    try {
      const res = await addPubStaff({ pubId: pub.id, nickname: search });
      if (res.code === 200) {
        alert("직원 등록이 되었습니다.");
        getStaffList();
      }
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function deleteStaff(staffId: number) {
    if (!pub) return;
    setLoading(true);
    try {
      const res = await deletePubStaff(staffId);

      alert(res.message);
      getStaffList();
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getStaffList();
  }, []);

  return (
    <PopupContainer>
      <StaffPopupWrapper>
        <StaffPopupLeft>
          <div className="header">
            <StaffTitle>직원 검색</StaffTitle>
            <StaffSearchInput
              type="text"
              placeholder="닉네임 검색"
              value={search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  addStaff();
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <StaffSearchButtonWrapper>
            <StaffSearchButton
              isSelected={true}
              onClick={() => {
                addStaff();
              }}
            >
              추가
            </StaffSearchButton>
            <StaffSearchButton
              isSelected={false}
              onClick={() => {
                setIsStaffManagementOpen(false);
              }}
            >
              취소
            </StaffSearchButton>
          </StaffSearchButtonWrapper>
        </StaffPopupLeft>
        <StaffPopupRight>
          <StaffTitle>직원 리스트</StaffTitle>
          <StaffList>
            {list.map((item) => (
              <StaffItem key={item.id}>
                <div className="item">{item.username}</div>
                <div className="item">{item.nickname}</div>

                <img
                  className="delete"
                  src="/image-web/edit/delete.svg"
                  alt="delete"
                  onClick={() => deleteStaff(item.id)}
                />
              </StaffItem>
            ))}
          </StaffList>
        </StaffPopupRight>
      </StaffPopupWrapper>
    </PopupContainer>
  );
};

export default StaffPopup;
